// ✅ File: src/components/Login.js
// ✅ Fully Updated — Correct Token/Auth Handling + Forgot Password Modal (2025-10-26)

//import { useState, useContext } from "react";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { AuthContext } from "../context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function Login() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  const [showForgot, setShowForgot] = useState(false);
  const [resetInput, setResetInput] = useState("");
  const [resetMessage, setResetMessage] = useState("");

  const generateCaptcha = () => {
    const chars =
        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";

    let value = "";

    for (let i = 0; i < 6; i++) {
        value += chars.charAt(
            Math.floor(Math.random() * chars.length)
        );
    }

    setCaptcha(value);
    setCaptchaInput("");
};
useEffect(() => {
  generateCaptcha();
}, []);

  // ✅ Successful Login Handler
  
  // ✅ Login API
  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (captchaInput.trim() !== captcha) {
    setError("Invalid captcha. Please try again.");
    generateCaptcha();
    return;
  }

  setLoading(true);

  try {
      const res = await axiosClient.post(
        "/auth/api/login",
        { username, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const { access_token, refresh_token } = res.data;

      if (!access_token || !refresh_token) {
          setError("❌ Missing authentication token(s) from server!");
          return;
      }

      login(null, access_token, refresh_token);
      generateCaptcha()
      navigate("/dashboard", { replace: true });
      
    } catch (err) {
      console.error("❌ Login failed:", err?.response?.data || err.message);
      setError("Invalid username or password");
      generateCaptcha();
    } finally {
      setLoading(false);
    }
  };

  // ✅ Request OTP API
  const handleRequestOtp = async (e) => {
    e.preventDefault();
    setResetMessage("");

    try {
      const res = await axiosClient.post("/auth/api/request-otp", {
        email: resetInput,
        username: resetInput,
        mobile: resetInput,
      });

      if (res.data.success) {
        setResetMessage("✅ OTP sent to your registered email");
        setTimeout(() => {
          setShowForgot(false);
          navigate("/verify-otp");
        }, 1500);
      } else {
        setResetMessage("⚠️ " + res.data.message);
      }
    } catch (err) {
      console.error("OTP Error:", err);
      setResetMessage("❌ Failed to send OTP, try again later");
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Segoe UI, sans-serif",
      }}
    >
      <div
        className="card shadow-lg border-0"
        style={{
          width: "100%",
          maxWidth: "420px",
          borderRadius: "15px",
          padding: "30px",
        }}
      >
        <div className="text-center mb-4">
          <h3 className="fw-bold text-dark">
            <i className="fas fa-sign-in-alt text-primary me-2"></i>
            TaskFlow Login
          </h3>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* ✅ Login Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Username</label>
            <input
              type="text"
              className="form-control"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i
                className={`fas ${
                  showPassword ? "fa-eye-slash" : "fa-eye"
                }`}
              ></i>
            </button>
          </div>
          </div>
             
             <div className="mb-3">
                <label className="form-label fw-semibold">Captcha</label>

                <div className="d-flex align-items-center mb-2">
                  <div
                    className="border rounded px-3 py-2 fw-bold text-primary"
                    style={{
                      letterSpacing: "3px",
                      userSelect: "none",
                      minWidth: "150px",
                      textAlign: "center",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    {captcha}
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-secondary ms-2"
                    onClick={generateCaptcha}
                    title="Refresh Captcha"
                  >
                    <i className="fas fa-sync-alt"></i>
                  </button>
                </div>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter captcha"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  required
                />
              </div>   
          <button
            className="btn btn-primary w-100 py-2"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Logging in...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt me-2"></i> Login
              </>
            )}
          </button>
        </form>

        {/* ✅ Forgot Password Button */}
        <div className="text-center mt-3">
          <button
            className="btn btn-link text-primary"
            type="button"
            onClick={() => setShowForgot(true)}
          >
            Forgot Password?
          </button>
        </div>
      </div>

      {/* ✅ OTP Modal */}
      {showForgot && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Request OTP</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowForgot(false);
                    setResetInput("");
                    setResetMessage("");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleRequestOtp}>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Email / Username / Mobile
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={resetInput}
                      onChange={(e) => setResetInput(e.target.value)}
                    />
                  </div>

                  {resetMessage && (
                    <div className="alert alert-info">{resetMessage}</div>
                  )}

                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => setShowForgot(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Send OTP
                    </button>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
